var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, autorun, computed, observable, reaction } from 'mobx';
import Keycloak from 'keycloak-js';
export class AuthStore {
    constructor(keycloakUrl, clientId, allowedRoles) {
        this.allowedRoles = allowedRoles;
        this.authStatus = 'PENDING';
        this.initKeycloak = () => {
            this.keycloak
                .init({
                onLoad: 'login-required',
                checkLoginIframeInterval: 1,
            })
                .then((authenticated) => __awaiter(this, void 0, void 0, function* () {
                if (authenticated) {
                    this.keycloak.loadUserProfile().then((resp) => {
                        this.updateUser(resp);
                        if (this.allowedRoles.map((r) => this.keycloak.hasRealmRole(r)).find((r) => r)) {
                            this.authStatus = 'AUTHENTICATED';
                        }
                        else {
                            this.authStatus = 'UNAUTHORIZED';
                        }
                    });
                    setInterval(() => {
                        this.keycloak.updateToken(400).catch(() => this.keycloak.logout());
                    }, 300000);
                }
                else {
                    this.authStatus = 'NOT_AUTHENTICATED';
                }
            }));
        };
        this.onLoggedIn = (onLoggedInCallback) => reaction(() => this.isLoggedIn, (loggedIn) => loggedIn && onLoggedInCallback(), {
            fireImmediately: true,
        });
        this.keycloak = new Keycloak({
            clientId,
            realm: 'france-active-internal',
            url: keycloakUrl,
        });
        autorun(() => this.initKeycloak());
    }
    get isLoggedIn() {
        return !!this.user;
    }
    get authHeader() {
        return `Bearer ${this.keycloak.token}`;
    }
    get token() {
        return this.keycloak.token || '';
    }
    get id() {
        return (this.user && this.user.id) || '';
    }
    updateUser(resp) {
        this.user = Object.assign(Object.assign({}, resp), { id: this.keycloak.subject });
    }
    logout() {
        this.keycloak.logout();
    }
    login() {
        this.keycloak.login();
    }
}
__decorate([
    observable
], AuthStore.prototype, "user", void 0);
__decorate([
    observable
], AuthStore.prototype, "authStatus", void 0);
__decorate([
    computed
], AuthStore.prototype, "isLoggedIn", null);
__decorate([
    computed
], AuthStore.prototype, "authHeader", null);
__decorate([
    computed
], AuthStore.prototype, "token", null);
__decorate([
    computed
], AuthStore.prototype, "id", null);
__decorate([
    action
], AuthStore.prototype, "initKeycloak", void 0);
__decorate([
    action
], AuthStore.prototype, "updateUser", null);
__decorate([
    action
], AuthStore.prototype, "logout", null);
__decorate([
    action
], AuthStore.prototype, "login", null);
//# sourceMappingURL=AuthStore.js.map